import { useCallback } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { getApplicationInfo, getDatalist, getProspectId } from "../store/selectors/appConfig";
import {
  getIsEditableStatusSearchInfo,
  getSearchResultsStatuses
} from "../store/selectors/searchProspect";
import routes, { smeBaseName } from "../routes";
import { ACTION_TYPES, VIEW_IDS } from "../constants";

export const useDisplayScreenBasedOnViewId = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const applicationInfo = useSelector(getApplicationInfo);
  const prospectIdFromStore = useSelector(getProspectId);
  const isROScreens = useSelector(getIsEditableStatusSearchInfo);
  const statuses = useSelector(getSearchResultsStatuses);
  const { dulLicenseAuthority } = useSelector(getDatalist);

  const pushDisplayScreenToHistory = useCallback(
    (prospect, signatoryInfo) => {
      const newApplicationInfo = prospect ? prospect.applicationInfo : applicationInfo;
      const isDulTL = dulLicenseAuthority.some(
        tl => tl.value === prospect?.organizationInfo?.licenseIssuingAuthority
      );
      const defaultRoute = isDulTL ? routes.dulServices : routes.companyInfo;
      const viewId =
        signatoryInfo?.viewId ||
        newApplicationInfo?.viewId ||
        defaultRoute.replace(smeBaseName, "");
      const prospectId = prospect?.generalInfo?.prospectId || prospectIdFromStore;
      const isSubmit =
        newApplicationInfo?.actionType === ACTION_TYPES.submit &&
        prospect?.viewId === VIEW_IDS.SubmitApplication;
      const isRetrieveMode = newApplicationInfo?.retrieveMode;
      const isEditRedirect = location.pathname.includes(VIEW_IDS.SearchedAppInfo);
      const prospectStatus =
        (statuses || []).find(status => status.prospectId === prospectId)?.statusType || "";
      const signatoryStatus = signatoryInfo?.status?.statusType || "";
      const isSignatoryInPartnerDetailForm = viewId === VIEW_IDS.PartnerDetailsInfo;

      let url;
      if (isSignatoryInPartnerDetailForm) {
        const pendingPartnerApplication = prospect?.signatoryInfo.find(
          signatory => !signatory.isApplicationFilled
        );
        const signatoryId = !prospect?.signatoryInfo.length
          ? "SID1"
          : pendingPartnerApplication?.signatoryId || `SID${prospect?.signatoryInfo?.length}`;
        url = `${smeBaseName}${viewId}/${signatoryId}`;
      } else {
        url = `${smeBaseName}${viewId}`;
      }

      if (isSubmit) {
        if (!isROScreens) {
          url = isRetrieveMode ? routes.ApplicationSubmitted : routes.additionalInformation;
        } else if (isEditRedirect) {
          url = routes.companyInfo;
        }
      }

      if (
        isROScreens &&
        [VIEW_IDS.ApplicationSubmitted, VIEW_IDS.ReUploadDocuments].includes(viewId)
      ) {
        url = routes.companyInfo;
      }

      if (prospectStatus === "INFO_REQUIRED" || signatoryStatus === "INFO_REQUIRED") {
        url = routes.additionalInformation;
      }

      navigate(url);
    },
    [
      applicationInfo,
      prospectIdFromStore,
      isROScreens,
      navigate,
      location,
      statuses,
      dulLicenseAuthority
    ]
  );

  return {
    pushDisplayScreenToHistory
  };
};
